import { useTranslation } from 'react-i18next'
import { SansText } from '../SansText/SansText'
import {
  FrontImageTogglerButton,
  FrontImageTogglerWrapper,
} from './FrontImageToggler.styles'
import type { FrontImageTogglerProps } from './FrontImageToggler.types'

export const FrontImageToggler = ({
  image,
  onToggle,
}: FrontImageTogglerProps): JSX.Element => {
  const { t } = useTranslation('collection-filters')

  return (
    <FrontImageTogglerWrapper>
      <SansText>{t('imageToggler_view')}</SansText>
      <FrontImageTogglerButton
        aria-label={t('imageToggler_side')}
        aria-pressed={image === 'standard'}
        active={image === 'standard'}
        onClick={onToggle}
      >
        {t('imageToggler_side')}
      </FrontImageTogglerButton>
      <SansText>|</SansText>
      <FrontImageTogglerButton
        aria-label={t('imageToggler_top')}
        aria-pressed={image === 'reverse'}
        active={image === 'reverse'}
        onClick={onToggle}
      >
        {t('imageToggler_top')}
      </FrontImageTogglerButton>
    </FrontImageTogglerWrapper>
  )
}
